import axios from 'axios';
import { BASE_URL } from './api';

export async function getSourceOwners(token) {
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/get_source_owners`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => {
        return response.data.source_owners
    })
    .catch(error => console.error(error))

}